import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../services/api/auth/auth.service";
import { environment } from "../../../environments/environment";

export const httpHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    (req.url.startsWith(environment.baseUrl + "/auth/") && !req.url.includes("/auth/user")) ||
    req.url.includes("assets")
  ) {
    return next(req);
  } else {
    const auth = inject(AuthService);
    const token = auth.getToken();
    if (token) {
      const modifiedReq = req.clone({
        headers: req.headers.set("Authorization", token),
      });
      return next(modifiedReq);
    } else {
      return next(req);
    }
  }
};
